import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PaymentForm from "./components/PaymentForm.js";
import FormSuccess from "./components/FormSuccess.js";
import FormFail from "./components/FormFail.js";
import AcquiringPage from "./components/AcquiringPage.js";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<PaymentForm />} />
          <Route path="/payment_form" element={<PaymentForm />} />
          <Route path="/form_success" element={<FormSuccess />} />
          <Route path="/form_fail" element={<FormFail />} />
          <Route path="/acquiring" element={<AcquiringPage />} />
          {/* Редирект на главную страницу для всех остальных маршрутов */}
          <Route path="*" element={<PaymentForm />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;